module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    staticStyle: {
      "margin-top": "20px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabLabel), function(item) {
    return _c('el-tab-pane', {
      key: item.tabType,
      attrs: {
        "label": item.label,
        "name": item.name
      }
    }, [_c('HCLTable', {
      staticStyle: {
        "margin-top": "13px"
      },
      attrs: {
        "tableData": item.tableData,
        "tabType": item.tabType,
        "pagesize": _vm.pagesize,
        "loading": _vm.Loading
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4034d8d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountAdmin/dataSTS/HCLStatistics.vue
// module id = 1459
// module chunks = 7